const form = {
  requiredEmail: "E-Mail-Adresse ist erforderlich.",
  requiredPassword: "Passwort ist erforderlich.",
  requiredUserType: "Bitte wählen Sie einen Kontotyp",
  dateMustBeComplete: "Das Datum muss vollständig sein.",
  requiredExample: "Beispiel ist erforderlich.",
  requiredFirstname: "Vorname ist erforderlich.",
  requiredLastname: "Nachname ist erforderlich.",
  requiredMessage: "Die Nachricht darf nicht leer sein.",
  requiredCity: "Stadt ist erforderlich.",
  validEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  tooLong: "Dieses Feld ist auf {value} Zeichen begrenzt.",
  subject: "Betreff",
  description: "Beschreibung",
  category: "Kategorie",
  acceptDataProcessing:
    "Ich stimme zu, dass meine Daten mit dem Entwicklungsteam geteilt werden dürfen.",
  invalidForm: "Ungültiges Formular.",
  requiredFields: "Felder, die mit * gekennzeichnet sind, sind Pflichtfelder.",
  allFieldsRequired: "Alle Felder sind Pflichtfelder.",
};

export default form;
